import Vue from 'vue'
import Vuex from 'vuex'

import banner from './banner'
import blog from './blog'
import empreendimentos from './empreendimentos'
import socialNetwork from './socialNetwork'
import contact from './contact'
import company from './company'
import purpose from './purpose'
import page from './page'
import diferential from './diferential'
import partner from './partner'
import seo from './seo'
import campaig from './campaig'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},

  actions: {},

  mutations: {},

  getters: {},

  modules: {
    banner,
    blog,
    empreendimentos,
    socialNetwork,
    contact,
    company,
    purpose,
    page,
    diferential,
    partner,
    seo,
    campaig
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js